/** * Значение является целым положительным числом
 * @param {string | number | undefined} value
 * @returns {boolean}
 */
export const isPositiveInteger = (value: string) => value !== undefined && /^\d+$/.test(value.toString());
/** * Значение НЕ является целым положительным числом
 * @param {string | number | undefined} value
 * @returns {boolean}
 */
export const notPositiveInteger = (value: string) => !isPositiveInteger(value);

/** для тега select, где выбранное значение является -1 или undefined */
export const noSelectValue = (value: string | number | undefined) => (value === '-1' || value === -1 || value === undefined);
/** для тега select, где выбранное значение есть и оно не -1 */
export const hasSelectValue = (value: string | number | undefined) => !noSelectValue(value);

/**
 * TODO: !delete, так как перенесен в helper/validation
 * проверка на наличие значения, чтоб оно не было null or undefined, но 0 можно
 * @param {string|number|null|undefined} value проверяемое значение
 */
export const hasValue = (value: string | number | undefined | null) => Boolean(value || value === 0);
/** @param {string|number|null|undefined} value проверяемое значение */
export const noValue = (value: string | number | undefined | null) => !hasValue(value);

/**
 * Проверка входит ли число в предел значений, включая границы.
 * @param {string|number} value значение, которое проверяем
 * @param {number} [min] нижний предел
 * @param {number} [max] верхний предел
 * @memberof utils
 */
export function isWithinMinMax({ value, min, max }: { value: string | number, min?: number, max?: number }): boolean {
  if (value === '') return true;

  const hasMin: boolean = hasValue(min);
  const hasMax: boolean = hasValue(max);

  let isValid = true;

  if (hasMin || hasMax) {
    const val: number = typeof value === 'string' ? +(value.replace(',', '.')) : value;
    // ! проверки через hasValue выше, а иначе ts ругается, несмотря на проверки
    const MIN = min as number;
    const MAX = max as number;

    if (!Number.isNaN(val)) {
      if (hasMin && hasMax) isValid = MIN <= val && val <= MAX;
      else if (hasMin) isValid = MIN <= val;
      else if (hasMax) isValid = val <= MAX;
    }
  }

  return isValid;
}
export const isOutsideMinMax = ({
  value, min, max,
}: { value: string | number, min?: number, max?: number }): boolean => {
  return !isWithinMinMax({ value, min, max });
};
